module.exports = {"toolbar":{"commons":{"lock":"Desbloquear herramientas","unlock":"Bloquear herramientas","automation":"Configuración de automatización"},"ungroup":{"button":"Desagrupar"},"group":{"button":"Agrupar"},"keyframe":{"button":"keyframe"},"image-object":{"button":"Editar"},"mask":{"button":"Máscara"},"unmask":{"button":"Desenmascarar"}}}


//////////////////
// WEBPACK FOOTER
// ./src/translations/es/toolbar.json
// module id = 799
// module chunks = 32